// 后端基址 —— 【唯一事实源】。2026-09-25 新增。
//
// 【改之前是什么样】
//   1) 16 个页面各自写死 `const baseUrl = "https://log.wuxiahaojie.com:443/api/XXX"`,
//      共 38 处。换机器 / 换域名 / 上正式服要逐个改,漏一处的现象是"个别页面还打旧机器",
//      页面不报错、只是数据不对 —— 肉眼验收发现不了。
//   2) 同时还有另一套:src/api/*.js + src/utils/request.js 走 VUE_APP_API_BASE_URL,
//      而 .env 里那个值是 `http://102.168.3.177:5000/api` —— IP 打错了(102 应为 192)、
//      端口也不是 gameInter 的 5058,而且 .env.production 和 .env.development 内容一模一样,
//      文件里还粘进了一整段 JS 代码。也就是说【照仓库配置打出来的包连不上后端】。
//      ⚠️src/api/*.js 那一层【没有任何页面 import】,是死代码;真正在用的是上面那 16 个页面。
//
// 【现在】所有页面统一从这里取,值由构建期环境变量决定。
// ⚠️Vue CLI 的环境变量是【构建期】注入的:换地址必须重新 npm run build,
//   光改服务器上的文件没用。部署脚本要把 build 和配置绑在一起。
//
// GAME_API = gameInter(游戏登录接口 + 运营后台接口,默认监听 5058)。
//   本后台的 Admin / FUWUQI / ActivityAdminService / Notice / GiftCard 控制器【都在 gameInter】,
//   2026-09-25 逐个核对过,不是 LoggerInter。
export const GAME_API = process.env.VUE_APP_GAME_API || 'http://127.0.0.1:5058';

export default GAME_API;
